<template>
  <v-dialog
    :value="dialog"
    :max-width="550"
    persistent
    :retain-focus="false"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card outlined>
      <div class="d-flex flex-nowrap align-center px-6 py-3">
        <div class="mr-auto">
          <v-list-item class="pa-0">
            <p-avatar
              :color="contact.color"
              :email="contact.displayEmail"
              :char="contact.avatarChar"
              :size="60"
              list-item-avatar
            ></p-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">{{ contact.displayName }}</v-list-item-title>
              <v-list-item-subtitle class="p-text-wrap">
                <v-chip
                  v-for="label of contact.labels"
                  :key="label"
                  class="mr-1 mb-1"
                  small
                  outlined
                >
                  {{ (contactLabelById(label) || {}).name }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div class="text-no-wrap">
          <p-btn-icon type="edit" @click="$parent.openEditDialog(contact)"></p-btn-icon>
          <contact-actions-menu :contact="contact"></contact-actions-menu>
          <p-btn-icon type="close" @click="close"></p-btn-icon>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="text--primary pt-4">
        <div
          v-if="contact.company"
          class="p-contact-details__row"
        >
          <v-icon>mdi-domain</v-icon>
          <div>{{ contact.company }}</div>
        </div>

        <div
          v-if="contact.email"
          class="p-contact-details__row"
        >
          <v-icon>mdi-email-outline</v-icon>
          <div>
            <a :href="'mailto:'+contact.email.email">
              {{ contact.email.email }}
            </a>
            <span class="p-caption"> • {{ contact.email.emailType.name }}</span>
          </div>
        </div>

        <div
          v-if="contact.phone"
          class="p-contact-details__row"
        >
          <v-icon>mdi-phone-outline</v-icon>
          <div>
            <a :href="'tel:'+contact.phone.phone">
              {{ contact.phone.phone }}
            </a>
            <span class="p-caption"> • {{ contact.phone.phoneType.name }}</span>
          </div>
        </div>

        <div
          v-if="contact.displayAddress"
          class="p-contact-details__row"
        >
          <v-icon>mdi-map-marker-outline</v-icon>
          <div>
            <a
              :href="'https://www.google.com/maps/place/'+contact.displayAddress"
              target="_blank"
            >
              {{ contact.displayAddress }}
            </a>
            <span class="p-caption"> • {{ contact.address.addressType.name }}</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters } from 'vuex'

import PAvatar from '@/components/PAvatar'
import PBtnIcon from '@/components/PBtnIcon'
import ContactActionsMenu from './ContactActionsMenu'


export default {
  components: {
    PAvatar,
    PBtnIcon,
    ContactActionsMenu
  },


  props: {
    dialog: Boolean,
    contact: Object
  },


  computed: {
    ...mapGetters('contactLabel', ['contactLabelById'])
  },


  methods: {
    close () {
      this.$emit('update:dialog', false)
    }
  }
}
</script>
